import { useRecoilValue } from 'recoil';
import type { Environment } from '~/engine/data/Environment';
import { petWindowMaxState } from '~/state/atoms/toolsAtoms';
import { useActiveEditTarget } from './useActiveEditTarget';

/**
 * The Environment whose views draw the SUV threshold panel's maximum
 * marker: the edit target the panel measures, while the panel publishes a
 * maximum; undefined otherwise. Resolved once per surface, so N tiles
 * compare their Environment to one answer.
 */
export function usePetMaxMarkerHost(): Environment | undefined {
    const windowMax = useRecoilValue(petWindowMaxState);
    const target = useActiveEditTarget();
    return windowMax ? target.environment : undefined;
}
